import React from "react";
import {
    getInvoiceSenderName,
    INVOICE_SENT_STATUS_LABELS,
} from "@common/helpers/domains/invoices/invoiceSentInfo";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { formatWorkspaceMemberFilterLabel } from "@components/pageHeader/filters/workspaceMemberFilter.lib";

interface Props {
    filters: FiltersTypes;
}

export const InvoiceSentFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: members } = useCurrentWorkspaceMembers();
    const { sentStatuses, sentByUserIds } = filters;

    const parts = (sentStatuses ?? []).map(
        (sentStatus) => INVOICE_SENT_STATUS_LABELS[sentStatus],
    );
    const senderLabel = formatWorkspaceMemberFilterLabel({
        userIds: sentByUserIds,
        members,
        getName: getInvoiceSenderName,
    });
    if (senderLabel) {
        parts.push(`by ${senderLabel}`);
    }

    if (parts.length === 0) {
        return null;
    }

    return <span>{parts.join(", ")}</span>;
};
